import { useRouter } from '@Helpers/useRouter';

export const useIsProfileComplete = () => {
  const { params } = useRouter();
  const isProfileComplete = Boolean(params.completeProfile);

  return { isProfileComplete } as const;
};
